import { Link } from "react-router-dom"
import amazonPrimeLogo from "../utils/images/amazon_prime_logo.jpeg"
import netflixLogo from "../utils/images/netflixLogo.webp"
import paramountLogo from "../utils/images/paramountLogo.png"
import paramountWithShowtime from "../utils/images/paramountWithShowtime.png"
import huluLogo from "../utils/images/huluLogo.webp"
import disneyPlus from "../utils/images/DisneyPlus.jpeg"
import appleTvlogo from "../utils/images/AppleTvlogo.png"
import iplayerLogo from "../utils/images/iplayerLogo.png"
import mubiLogo from "../utils/images/mubiLogo.png"
import hboMaxLogo from "../utils/images/HboMax.png"
import britboxLogo from "../utils/images/BritboxLogo.png"
import peacock from "../utils/images/peacock.png"
import zee5 from "../utils/images/zee5.png"
import starz from "../utils/images/starzplayLogo.png"

const ServiceStreamingImages = ({ service, link }) => {

    const serviceStreamingLogo = {
        apple: appleTvlogo,
        disney: disneyPlus,
        hbo: hboMaxLogo,
        hulu: huluLogo,
        iplayer: iplayerLogo,
        mubi: mubiLogo,
        netflix: netflixLogo,
        paramount: paramountLogo,
        prime: amazonPrimeLogo,
        showtime: paramountWithShowtime,
        britbox: britboxLogo,
        peacock: peacock,
        zee5: zee5,
        starz: starz,
    }
    return <div className="shadow-md rounded-md mt-5">
        {serviceStreamingLogo[service] ? (<Link to={link} className="row-span-2 col-span-2">
            <img className="w-10 h-10 rounded-md" src={serviceStreamingLogo[service]} alt={service} />
        </Link>) : (
            <Link to={link} className="row-span-2 col-span-2">
                <div className="w-10 h-10 rounded-md shadow"> Not Found</div>
            </Link>
        )}
    </div>
}

export default ServiceStreamingImages